/**
 * When deployed, the pricing pages should just be under
 * '/public-pricing', however when testing locally and on the proxy during dev
 * we have different URLs (e.g. /public-pricing-pt-br-service) that'll break
 * if we don't grab the path dynamically.
 *
 * `pathname` defaults to `window.location.pathname` so callers stay
 * arg-free in prod, but tests can pass a literal and skip stubbing
 * the global `window.location` (which is non-configurable in jsdom and
 * leaks across async tests).
 */
export const getPublicPagePath = (pathname = window.location.pathname) => {
  const [, firstSegment, secondSegment] = pathname.split('/');
  // One-time exception for the IB preview. Do not add another cohort this
  // way without presenting an RFC to the pricing page team first.
  if (secondSegment === 'ib-pricing') {
    return `/${firstSegment}/ib-pricing`;
  }
  return `/${firstSegment}`;
};